module.exports = __webpack_public_path__ + "img/ico8.c5a346fd.svg";